import Text from '~/components/UI/Text'

export const getContent1 = (t: any) => ([
  {
    col1: t`Vốn đầu tư`,
  },
  {
    col1: t`Từ 2 tỉ trở lên`,
    col2: t`Chỉ từ 20 triệu mỗi phần và có thể mua số lượng tuỳ ý`
  },
  {
    col1: t`Thanh toán`
  },
  {
    col1: t`Theo tiến độ của chủ đầu tư hoặc thanh toán hết 1 lần`,
    col2: t`Theo tiến độ của chủ đầu tư hoặc thanh toán hết 1 lần`
  }
])


export const getContent2 = (t: any) => ([
  {
    col1: t`Lợi nhuận khi bất động sản tăng giá`,
  },
  {
    col1: (
      <>
        <Text>
          {t`Lợi nhuận = (Giá bán - Giá mua)`}
        </Text>
        <Text>
          {t`Lợi nhuận có thể là số 0 hoặc là số âm`}
        </Text>
      </>
    ),
    col2: t`Lợi nhuận tối thiểu (tuỳ vào từng dự án đang được mở đầu tư) + lợi nhuận khi bất động sản tăng giá`
  },
  {
    col1: t`Thanh khoản - Thoát Vốn`
  },
  {
    col1: t`Phụ thuộc thị trường, trung bình 3 tháng mới bán được`,
    col2: t`4 hình thức chốt lời: Sàn giao dịch mua bán, bán trực tiếp cho bạn bè/ người quen, bán nguyên căn, bán lại cho Infina`
  },
  {
    col1: t`Thời điểm chốt lời`
  },
  {
    col1: t`Phụ thuộc thị trường`,
    col2: t`Có thể chốt lời bất cứ lúc nào thông qua các hình thức chốt lời nêu trên`
  },
  {
    col1: t`Khi thị trường đóng băng hoặc đi xuống, dụ án gặp trục trặc`
  },
  {
    col1: t`Không thể bán ra hoặc bán chịu lỗ`,
    col2: t`Bán lại cho Infina với lợi nhuận được cam kết và được ngân hàng bảo lãnh`
  },
  {
    col1: t`Chủ đầu tư hoặc Infina phá sản`,
  },
  {
    col1: t`Mất toàn bộ số tiền`,
    col2: t`Ngân hàng bảo lãnh`
  }
])


export const getContent3 = (t: any) => ([
  {
    col1: t`Nghiên cứu đánh giá sản phẩm`,
  },
  {
    col1: t`Tự đặt cọc, tham gia mở bán, ký hợp đồng, làm việc với chủ đầu tư`,
    col2: t`Infina sẽ thay bạn hoàn thành tất cả quá trình mua bán và quản lý bất động sản.`
  },
  {
    col1: t`Hợp đồng`
  },
  {
    col1: t`Ký hợp đồng với chủ đầu tư`,
    col2: t`Ký hợp đồng với Infina, Infina ký hợp đồng với chủ đầu tư`
  },
  {
    col1: t`Hình thức hợp đồng`
  },
  {
    col1: t`Hợp đồng giấy, nhiều thủ tục rườm rà, phải tự thực hiện.`,
    col2: t`Hợp đồng điện tử, được nhân viên của Infina hỗ trợ tận tình.`
  }
])
